"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelSidebarView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const useAuth_1 = require("../../lib/hooks/useAuth");
const Wrap = app_1.styled.div `
  min-height: 100vh;
  background: #fbfbfb;
  padding: ${(theme) => theme.spacing.medium};
  padding-top: 9.5rem;
  display: flex;
  flex-direction: column;
  color: ${(theme) => theme.colors.gray.semidark};
  z-index: 1;
  overflow: auto;
  @media ${app_1.mobile} {
    display: ${(_theme, { $open }) => ($open ? 'flex' : 'none')};
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: ${(theme) => theme.spacing.small};
    padding-top: 6rem;
  }
`;
const Title = (0, app_1.styled)(app_1.Text) `
  margin-bottom: ${(theme) => theme.spacing.small};
  font-weight: 500;
  color: #000000;
  font-size: 1.375rem;
`;
const Description = (0, app_1.styled)(app_1.Text) `
  font-size: 0.9375rem;
  white-space: pre-line;
  line-height: 150%;
  @media ${app_1.mobile} {
    white-space: unset;
  }
`;
const MainSection = (0, app_1.styled)(ui_1.Stack) `
  flex: 1;
  margin-bottom: ${(theme) => theme.spacing.small};
`;
const ListLinkContent = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
  color: ${(theme) => theme.colors.gray.semidark};
  font-size: 0.9375rem;
  letter-spacing: 0.00625rem;
  line-height: 150%;
`;
const BottomLink = (0, app_1.styled)(app_1.Link) `
  color: ${(theme) => theme.colors.gray.light};
`;
const StyledLink = (0, app_1.styled)(app_1.Link) `
  &[aria-current] {
    * {
      color: black;
      font-weight: bold;
    }
  }
`;
const ButtonLink = (0, app_1.styled)(ui_1.Button) `
  min-width: 0;
  height: auto;
  display: block;
  margin: 0;
  padding: 0;
  text-align: left;
  color: ${(theme) => theme.colors.gray.semidark};
  &:hover {
    background: transparent;
  }
`;
function ListLink({ href, icon: Icon, text }) {
    return ((0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "li" }, { children: (0, jsx_runtime_1.jsx)(StyledLink, Object.assign({ href: href }, { children: (0, jsx_runtime_1.jsxs)(ListLinkContent, { children: [(0, jsx_runtime_1.jsx)(Icon, {}), (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: text }))] }) })) })));
}
function UserPanelSidebarView({ user, open, }) {
    const { t } = (0, app_1.useTranslation)();
    const { logout } = (0, useAuth_1.useAuth)();
    const ecomHref = (0, app_1.useContextPath)('ecommerce');
    const wishlistHref = (0, app_1.useContextPath)('ecommerce.userPanel.wishlist');
    const ordersHref = (0, app_1.useContextPath)('ecommerce.userPanel');
    const settingsHref = (0, app_1.useContextPath)('ecommerce.userPanel.settings');
    const addressesHref = (0, app_1.useContextPath)('ecommerce.userPanel.addresses');
    const privacyPolicyPath = (0, app_1.useContextPath)('privacyPolicy');
    const tosPath = (0, app_1.useContextPath)('tos');
    return ((0, jsx_runtime_1.jsxs)(Wrap, Object.assign({ "$open": open }, { children: [(0, jsx_runtime_1.jsx)(Title, Object.assign({ tag: "h2" }, { children: t('text.welcomeWithName', { name: user.name.trim().split(' ')[0] }) })), (0, jsx_runtime_1.jsxs)(MainSection, Object.assign({ kind: "vertical", spacing: "medium" }, { children: [(0, jsx_runtime_1.jsx)(Description, { children: t('user.welcomeMsg') }), (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", list: true, spacing: "small" }, { children: [(0, jsx_runtime_1.jsx)(ListLink, { icon: svg_1.SvgShoppingCart, text: t('store.ordersAndReturns'), href: ordersHref }), (0, jsx_runtime_1.jsx)(ListLink, { icon: svg_1.SvgUser, text: t('user.accountSettings'), href: settingsHref }), (0, jsx_runtime_1.jsx)(ListLink, { icon: svg_1.SvgPackage, text: t('store.Addresses'), href: addressesHref }), (0, jsx_runtime_1.jsx)(ListLink, { icon: svg_1.SvgHeart, text: t('store.wishlist'), href: wishlistHref })] })), (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "small" }, { children: [(0, jsx_runtime_1.jsx)(ButtonLink, Object.assign({ kind: "transparent", href: ecomHref }, { children: t('store.backtoShoppingButton') })), (0, jsx_runtime_1.jsx)(ButtonLink, Object.assign({ kind: "transparent", onClick: logout }, { children: t('label.logOut') }))] }))] })), (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "small" }, { children: [(0, jsx_runtime_1.jsx)(BottomLink, Object.assign({ href: privacyPolicyPath }, { children: t('info.PrivacyPolicy') })), (0, jsx_runtime_1.jsx)(BottomLink, Object.assign({ href: tosPath }, { children: t('info.termsOfService') }))] }))] })));
}
exports.UserPanelSidebarView = UserPanelSidebarView;
